// extracted by mini-css-extract-plugin
export var actionText = "_sg-4";
export var container = "_sg-0";
export var leftSection = "_sg-1";
export var rightSection = "_sg-2";
export var settingsButton = "_sg-6";
export var settingsIcon = "_sg-7";
export var shortcut = "_sg-5";
export var shortcutGroup = "_sg-3";